import { useEventBus } from '../use-event-bus/use-event-bus';
import type { LocaleMessages } from 'vue-i18n';

export type NotificationOptions = {
  message: string | LocaleMessages;
  topPositioning?: string;
};

/**
 * Composable to trigger a notification banner by emitting the
 * `setNotificationData` event on the global event emitter.
 */
export function useNotification() {
  const eventEmitter = useEventBus();

  function openNotification(options: NotificationOptions): void {
    if (!eventEmitter) {
      console.warn('useNotification: event bus is not available');
      return;
    }

    eventEmitter.$emit('setNotificationData', options);
  }

  return { openNotification };
}
